// UNCARVED DOMAIN KEY (ads, ADS-229): advertisements / HCP verification has no
// workspace package, so there is no /contracts door to declare this react-query
// identity in.
// eslint-disable-next-line @heidi/rules/no-new-cache-key-declaration -- react-query identity for GET /hcp-verifications:status until the ads domain carves out
export const GET_HCP_VERIFICATIONS_QUERY_KEY = 'getHcpVerifications';
